import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-item-header',
  templateUrl: './action-item-header.component.html',
  styleUrls: ['./action-item-header.component.scss']
})
export class ActionItemHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
